The success result for the `updateUploadedCandidatePerson` mutation.
